import { render, staticRenderFns } from "./Demos.vue?vue&type=template&id=40329f46&scoped=true&"
import script from "./Demos.vue?vue&type=script&lang=js&"
export * from "./Demos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40329f46",
  null
  
)

export default component.exports